import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';
import Label from 'components/_utility/Label';
import {
  getConflictingAccessories,
  getPendingConflictingAccessories,
  getConflictChoice,
} from 'src/redux/bike/selectors';
import AccessoryChoiceGroup from 'components/AccessoryChoiceGroup/AccessoryChoiceGroup';
import { closeAccessoryResolution, resolveAccessoryConflict, setConflictChoice } from 'src/redux/bike/actions';
import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from './ConflictingAccessories.styled';
import useDataLayer from 'src/hooks/useDataLayer';

const ConflictingAccessories = () => {
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();

  const conflictingAccessories = useSelector(getConflictingAccessories);
  const pendingConflictingAccessories = useSelector(getPendingConflictingAccessories);
  const choice = useSelector(getConflictChoice);

  const handleChoose = choiceId => dispatch(setConflictChoice(choiceId));

  const handleResolveConflict = () => {
    const chosenAccessory = choice === 'new' ? pendingConflictingAccessories[0] : conflictingAccessories[0];

    pushToDataLayer('configuratorAccessoryConflict', {
      configuratorAccessoryID: chosenAccessory.partNumber,
      configuratorAccessoryName: chosenAccessory.name,
      configuratorAccessoryPrice: chosenAccessory.price,
    });

    return dispatch(resolveAccessoryConflict());
  };

  return (
    <Wrap>
      <Title>
        <Label name="conflictingAccessoryTitle" />
      </Title>

      <Description>
        <Label name="conflictingAccessoryDescription" />
      </Description>

      <Scrollbar noDefaultStyles>
        <Heading>
          <Label name={conflictingAccessories.length > 1 ? 'conflictsLabel' : 'accessoriesLabel'} />
        </Heading>

        <AccessoryChoiceGroup
          id="existing"
          accessories={conflictingAccessories}
          onChoose={handleChoose}
          selected={choice === 'existing'}
        />

        {pendingConflictingAccessories.length > 1 || conflictingAccessories.length > 1 ? (
          <Heading>
            <Label name="newPartLabel" />
          </Heading>
        ) : null}

        <AccessoryChoiceGroup
          id="new"
          accessories={pendingConflictingAccessories}
          onChoose={handleChoose}
          selected={choice === 'new'}
        />

        <Actions>
          <ConfirmButton primary disabled={!choice} onClick={handleResolveConflict}><Label name="confirmLabel"></Label></ConfirmButton>
          <CancelButton onClick={() => dispatch(closeAccessoryResolution())}><Label name="cancelLabel"></Label></CancelButton>
        </Actions>
      </Scrollbar>
    </Wrap>
  );
};

export default ConflictingAccessories;
